export default "__VITE_ASSET__VDapvhSQ__"